import { createListCollection, Field as ChakraField, Fieldset } from '@chakra-ui/react';
import { CockpitFormLayout } from '@components/cockpit/layouts/CockpitFormLayout';
import ModifiedTag from '@components/common/form/ModifiedField';
import MultiSelect from '@components/ui/multiSelect/MultiSelect';
import { useAppSelector } from '@hooks/redux.hooks';
import { PilotSelectors } from '@redux/utm/utm.selectors';
import { haveSameUniqueElements } from '@utils/common.utils';
import { getPilotName } from '@utils/utm/pilot.utils';
import { useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';

import { PartialDrone } from '@/types/utm/drone.types';

export default function DronePilotsTab() {
  const pilots = useAppSelector(PilotSelectors.selectAllPilots);
  const { errors, touched, initialValues, values, setFieldValue } = useFormikContext<PartialDrone>();

  return (
    <CockpitFormLayout title="components.utm.drones.tab.pilots.title">
      <Fieldset.Root invalid={Object.keys(errors).some((key) => touched[key as keyof typeof touched])}>
        <ChakraField.Root variant="cockpit">
          <ChakraField.Label width="100%" height="20px">
            <FormattedMessage id="components.utm.drones.tab.pilots.title" />
            {!haveSameUniqueElements(values.pilots!, initialValues.pilots!) && <ModifiedTag />}
          </ChakraField.Label>
          <MultiSelect
            values={values.pilots?.map((pilot) => pilot.code) ?? []}
            label="components.utm.drones.tab.pilots.add"
            collection={createListCollection({
              items: pilots.map((pilot) => ({
                label: getPilotName(pilot),
                value: pilot.code,
              })),
            })}
            onChange={(values) =>
              setFieldValue(
                'pilots',
                pilots.filter((pilot) => values.includes(pilot.code)),
              )
            }
          />
        </ChakraField.Root>
      </Fieldset.Root>
    </CockpitFormLayout>
  );
}
